import React from 'react';
import { motion, Variants } from 'framer-motion';
interface WordFadeInProps {
  words: string;
  className?: string;
  delay?: number;
  variants?: Variants;
}
export function WordFadeIn({
  words,
  delay = 0.15,
  variants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: (i: number) => ({
      y: 0,
      opacity: 1,
      transition: {
        delay: i * delay
      }
    })
  },
  className = ''
}: WordFadeInProps) {
  const _words = words.split(' ');
  return <motion.div variants={variants} initial="hidden" animate="visible" className={className} data-id="element-268">
      {_words.map((word, i) => <motion.span key={word + i} variants={variants} custom={i} className="inline-block mr-[0.15em] last:mr-0" data-id="element-269">
          {word}
        </motion.span>)}
    </motion.div>;
}